import { ReactComponent } from './stepper-minus-s.svg';
export const StepperMinusIconS = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=stepper-minus-s.js.map